const hooks = [
  "beforeCreate",
  "created",
  "beforeMount",
  "mounted",
  "beforeDestroy",
  "destroyed",
  "beforeUpdate",
  "updated",
];

const _mergeHook = (component, hook_name) => {
  const proto = component.prototype;
  const cache = proto[hook_name];
  const parentHook = Object.getPrototypeOf(proto)[hook_name];
  proto[hook_name] = function(...args) {
    if (parentHook) {
      parentHook.apply(this, args);
    }
    if (cache) {
      cache.apply(this, args);
    }
  };
  return component;
};

const MergeHooks = (options) => {
  if (typeof options === "function") {
    return mergeHooksFactory(options);
  }
  return (component) => mergeHooksFactory(component, options);
};

const mergeHooksFactory = (component, options = hooks) => {
  options.forEach((hook) => _mergeHook(component, hook));
  return component;
};

export default MergeHooks;
